import React from 'react';
import { Phone } from 'lucide-react';
import QuickCallButton from '../../customers/ui/QuickCallButton';
import { callTypeForTicket, sourceModuleForTicket, dialableMobile } from '../logic/ticketCall';

/**
 * Call the ticket's customer — the app's ONE dial path (QuickCallButton →
 * dialViaPhone → /api/tc/call/start → the agent's Daksha Caller app), and the
 * result is logged through CallActivityService with this ticket's id, so it shows
 * in the Telecaller Workspace like every other call. Never a bare tel: link.
 *
 *   variant="icon"  — a compact icon for table rows
 *   variant="pill"  — a labelled "Call" button for headers and cards
 */
const TicketCallButton = ({ ticket, customerName, variant = 'icon', className, iconSize = 16 }) => {
    const mobile = dialableMobile(ticket);
    if (!ticket || !mobile) return null;
    const pill = variant === 'pill';
    return (
        <QuickCallButton
            mobile={mobile}
            customerName={customerName || ticket.customerName || ''}
            ticketId={ticket.id || ''}
            orderId={ticket.orderId || ''}
            sourceModule={sourceModuleForTicket(ticket)}
            callType={callTypeForTicket(ticket)}
            title={`Call ${customerName || ticket.customerName || mobile} (${mobile})`}
            iconSize={iconSize}
            label={pill ? <span className="inline-flex items-center gap-1"><Phone size={iconSize} /> Call</span> : undefined}
            className={className || (pill
                ? 'px-2 py-1 rounded-lg text-[11px] font-bold bg-green-50 text-green-700 border border-green-200 hover:bg-green-100'
                : 'p-1.5 hover:bg-green-100 rounded-lg text-green-600')}
        />
    );
};

export default TicketCallButton;
